/** Biome treats `useRef(null)` as permanently null, so callers read the node through this. */
export const readRef = <T>(ref: { readonly current: T }): T => ref.current;
